<template>
  <div class="markdown-container markdown-body" v-html="renderedContent"></div>
</template>

<script>
  import Vue from 'vue';
  import MarkdownIt from 'markdown-it';
  import katex from 'katex';
  import texmath from 'markdown-it-texmath';
  import 'katex/dist/katex.min.css';
  import '@/common/less/markdown.css';

  export default Vue.extend({
    name: 'MarkdownRenderer',
    props: {
      content: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        md: new MarkdownIt({
          html: true,
          linkify: true,
          typographer: true,
          breaks: true,
        }).use(texmath, {
          engine: katex,
          delimiters: 'dollars', // 使用 $...$ 和 $$...$$ 语法
          katexOptions: {
            throwOnError: false,
            displayMode: false,
          },
        }),
      };
    },
    computed: {
      renderedContent() {
        return this.md.render(this.content);
      },
    },
  });
</script>

<style lang="less">
  .markdown-container {
    line-height: 1.6;
  }

  .markdown-container :deep(pre) {
    background-color: #f5f5f5;
    padding: 10px;
    border-radius: 4px;
    overflow-x: auto;
  }

  .markdown-container :deep(code) {
    background-color: #f5f5f5;
    padding: 2px 6px;
    border-radius: 3px;
    font-family: monospace;
  }

  .markdown-container :deep(.katex-error) {
    color: red;
  }
</style>
